import { Component, EventEmitter, Output, OnInit, OnDestroy  } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, firstValueFrom } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { CuentaBeneficiario } from 'src/app/dashboard/interfaces/cuenta-beneficiario.interface';
import { AccountRecipientService } from 'src/app/dashboard/services/account-recipient.service';
import AddAccountComponent from 'src/app/dashboard/components/account-recipient/components/add-account/add-account.component';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/dashboard/services/user.service';

@Component({
  selector: 'app-beneficiary-fiat',
  templateUrl: './beneficiary-fiat.component.html',
  styleUrls: ['./beneficiary-fiat.component.sass']
})
export class BeneficiaryFiatComponent implements OnInit, OnDestroy{

  public subscription: Subscription = new Subscription();
  public user: any;
  public searchTxt: string = '';
  public wordFilter: string = '';

  constructor(
    private dialog: MatDialog,
    private recipientService: AccountRecipientService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private userService: UserService
  ){}
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.store.select('auth').subscribe(async ({ user }: any) => {
        const userIdFromRoute = this.activatedRoute.snapshot.paramMap.get('email');
        if (userIdFromRoute) {
          const userData: any = await firstValueFrom(this.userService.getUserData(userIdFromRoute));
          this.user = userData.user;
        }else{
          this.user = user;
        }

        await this.getBeneficiarios();
      })
    );
  }

  @Output()
  public changeStep = new EventEmitter<number>();

  @Output()
  public beneficiarioOutput = new EventEmitter<CuentaBeneficiario>();

  @Output()
  public goBack = new EventEmitter<any>();

  public beneficiarioEscogido:CuentaBeneficiario | undefined = undefined;

  public listaBeneficiarios:CuentaBeneficiario[] = [];
  public listaBeneficiariosFiltrados:CuentaBeneficiario[] = [];

  openCreateDialog(){
    const isMobile = window.innerWidth < 768;
    const dialogRef = this.dialog.open(AddAccountComponent, {
      data: {
      userID: this.user?.usuarioId,
      type: 'CREATE',
      },
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '620px',
      minWidth: isMobile ? '90vw' : '560px',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe(async result => {
      if(result == true ){
        this.getBeneficiarios();
      }
    })

  }

  clearInput() {
    this.searchTxt = '';
  }

  elegir( beneficiario: CuentaBeneficiario ):void{
    if(this.beneficiarioEscogido === beneficiario ){
      this.beneficiarioEscogido = undefined;
      return;
    }
    this.beneficiarioEscogido = beneficiario;
  }

  emitChangeStep( ): void{
    this.changeStep.emit( 2 );
    this.beneficiarioOutput.emit( this.beneficiarioEscogido );
  }

  async getBeneficiarios(): Promise<void>{
    this.listaBeneficiarios = await this.recipientService.getByUser(this.user?.email);
    this.listaBeneficiariosFiltrados = this.listaBeneficiarios;
  }

  buscar(event: KeyboardEvent): void {
    var searchWord = this.searchTxt.toLowerCase();
    if(searchWord === '') {
      this.listaBeneficiariosFiltrados = this.listaBeneficiarios;
      return;
    }
    this.listaBeneficiariosFiltrados = this.listaBeneficiarios.filter( beneficiario => {
      let nombreCompleto = beneficiario.nombre + " " + beneficiario.apellidos;
      return nombreCompleto.toLowerCase().includes(searchWord.toLowerCase());
    }
    )
  }

  goToBack(): void {
    this.goBack.emit();
  }

}
